import {
  SubscriptionPlan,
  VoiceAgentAccountLookupDataType,
  type VoiceAgentConfigurationAccountLookupInput
} from '~/api/graphql';

/** Pro and Enterprise plans include the Answer Policy Question tool (answer_question). */
export function subscriptionPlanHasAnswerPolicyQuestion(plan?: SubscriptionPlan | null): boolean {
  return plan === SubscriptionPlan.Pro || plan === SubscriptionPlan.Enterprise;
}

export const DISABLED_VOICE_ACCOUNT_LOOKUP: VoiceAgentConfigurationAccountLookupInput = {
  enabled: false,
  includedDataTypes: []
};

/** Clears account lookup when Voice 3.5 is not enabled. lookup_customer is not plan-gated. */
export function voiceAccountLookupForVoice35(
  accountLookup: VoiceAgentConfigurationAccountLookupInput,
  voice35Enabled: boolean
): VoiceAgentConfigurationAccountLookupInput {
  if (voice35Enabled) {
    return normalizeVoiceAccountLookup(accountLookup);
  }
  return DISABLED_VOICE_ACCOUNT_LOOKUP;
}

/** Strips unknown account lookup data types before save/load. */
export function normalizeVoiceAccountLookup(
  accountLookup: VoiceAgentConfigurationAccountLookupInput
): VoiceAgentConfigurationAccountLookupInput {
  const validTypes = new Set<string>(Object.values(VoiceAgentAccountLookupDataType));
  const includedDataTypes = accountLookup.includedDataTypes.filter((type) => validTypes.has(type));
  return { ...accountLookup, includedDataTypes };
}
